/* eslint no-undef: "off" */

export const API = Object.freeze({
  RATE:
    globalThis?.import_meta_env?.VITE_API_RATE || import.meta.env.VITE_API_RATE,
  ENDPOINT:
    globalThis?.import_meta_env?.VITE_API_ENDPOINT ||
    import.meta.env.VITE_API_ENDPOINT,
  EMCD_API:
    globalThis?.import_meta_env?.VITE_API_EMCD_API ||
    import.meta.env.VITE_API_EMCD_API,
  EMCD_API2:
    globalThis?.import_meta_env?.VITE_API_EMCD_API2 ||
    import.meta.env.VITE_API_EMCD_API2,
  EMCD_API4:
    globalThis?.import_meta_env?.VITE_API_EMCD_API4 ||
    import.meta.env.VITE_API_EMCD_API4,
  EMCD_P2P:
    globalThis?.import_meta_env?.VITE_API_P2P || import.meta.env.VITE_API_P2P,
  EMCD_P2P_2:
    globalThis?.import_meta_env?.VITE_API_P2P_2 ||
    import.meta.env.VITE_API_P2P_2,
  EMCD_GIFT_CARDS:
    globalThis?.import_meta_env?.VITE_API_EMCD_GIFT_CARDS ||
    import.meta.env.VITE_API_EMCD_GIFT_CARDS,
  EMCD_CARDS:
    globalThis?.import_meta_env?.VITE_API_EMCD_CARD ||
    import.meta.env.VITE_API_EMCD_CARD,
  AUTH:
    globalThis?.import_meta_env?.VITE_API_AUTH || import.meta.env.VITE_API_AUTH,
  CHAT:
    globalThis?.import_meta_env?.VITE_API_CHAT || import.meta.env.VITE_API_CHAT,
  DOWNLOAD_APP_URL:
    globalThis?.import_meta_env?.VITE_DOWNLOAD_APP_URL ||
    import.meta.env.VITE_DOWNLOAD_APP_URL,
  MINING_APP_DOWNLOAD_URL:
    globalThis?.import_meta_env?.VITE_MINING_APP_DOWNLOAD_URL ||
    import.meta.env.VITE_MINING_APP_DOWNLOAD_URL,
  TMA_BACKEND_URL:
    globalThis?.import_meta_env?.VITE_TMA_BACKEND_URL ||
    import.meta.env.VITE_TMA_BACKEND_URL,
  EMCD_URL:
    globalThis?.import_meta_env?.VITE_EMCD_URL || import.meta.env.VITE_EMCD_URL,
  RECAPTCHA_KEY:
    globalThis?.import_meta_env?.VITE_RECAPTCHA_KEY ||
    import.meta.env.VITE_RECAPTCHA_KEY,
  RECAPTCHA_V2_CHECKBOX:
    globalThis?.import_meta_env?.VITE_RECAPTCHA_V2_CHECKBOX ||
    import.meta.env.VITE_RECAPTCHA_V2_CHECKBOX,
  RECAPTCHA_V3_HIDE:
    globalThis?.import_meta_env?.VITE_RECAPTCHA_V3_HIDE ||
    import.meta.env.VITE_RECAPTCHA_V3_HIDE,
});

// Код ошибки в случае если пользователь не указал email при авторизации через Telegram
export const TG_AUTH_FAIL = "tg_auth-0003";
